module.exports = __webpack_public_path__ + "img/unimol-with-text.e708ea28.png";